import React from "react";
import StepBackwardSolidSVG from "../../www/assets/images/step_backward_solid.svg";
import PauseSolidSVG from "../../www/assets/images/pause_solid.svg";
import PlaySolidSVG from "../../www/assets/images/play_solid.svg";
import StepForwardSolidSVG from "../../www/assets/images/step_forward_solid.svg";

const animation_controls_btn = ({
  isPlaying,
  onTogglePlay,
  onPrevious,
  onNext,
}) => {
  return (
    <div className="animation-controls">
      <button className="controls-btn" onClick={onNext}>
        <StepForwardSolidSVG />
      </button>
      <button className="controls-btn" onClick={onTogglePlay}>
        {isPlaying ? <PauseSolidSVG /> : <PlaySolidSVG />}
      </button>
      <button className="controls-btn" onClick={onPrevious}>
        <StepBackwardSolidSVG />
      </button>
    </div>
  );
};

export default animation_controls_btn;
